import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const getStoreNotificationsAsync = createAsyncThunk(
  "admin/getStoreNotifications",
  async (_, toolkit) => {
    return await AxiosClient("GET", "/store/notifications", [], toolkit);
  }
);

export const getStoreNotificationUnreadCountAsync = createAsyncThunk(
  "admin/getStoreNotificationUnreadCount",
  async (_, toolkit) => {
    return await AxiosClient(
      "GET",
      "/store/notifications/unread-count",
      [],
      toolkit
    );
  }
);

export const viewStoreNotificationAsync = createAsyncThunk(
  "admin/viewStoreNotification",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PATCH",
      `/store/notifications/${payload?.id}`,
      [],
      toolkit
    );
  }
);

export const viewAllStoreNotificationsAsync = createAsyncThunk(
  "admin/viewAllStoreNotifications",
  async (_, toolkit) => {
    return await AxiosClient(
      "PATCH",
      "/store/notifications/view-all",
      [],
      toolkit
    );
  }
);
